import type { OfferType } from '@makemydeal/dr-platform-types';
import { BALLOON, FINANCE, LEASE } from '@makemydeal/dr-platform-types';

export const CALCULATED_BADGE = 'No Program';
export const LENDER_PROGRAM_SOURCED_BADGE = 'Lender Program Sourced';

export const DEAL_TYPE_SOURCE_BADGE_TEST_ID = 'deal-type-source-badge';

export const BADGED_OFFER_TYPES: OfferType[] = [LEASE, FINANCE, BALLOON];

export const CASH_FALLBACK_NOTICE_TEST_ID = 'cash-fallback-notice';
